import api from './api';

// ============================================================
// Service da Régua de Cobrança (T2 / Camada 2).
// Espelha back/controller/cobranca/Controller.ReguaCobranca.pas:
//   GET    /v1/regua-cobranca/etapas
//   PUT    /v1/regua-cobranca/etapas/:id
//   GET    /v1/regua-cobranca/eventos
//   GET    /v1/regua-cobranca/eventos/contar
//   GET    /v1/regua-cobranca/engine/status
//   GET    /v1/regua-cobranca/smtp/teste
// ============================================================

const BASE = '/v1/regua-cobranca';

export const listarEtapas = async () => {
  const { data } = await api.get(`${BASE}/etapas`);
  return data;
};

export const atualizarEtapa = async (id, payload) => {
  const { data } = await api.put(`${BASE}/etapas/${id}`, payload);
  return data;
};

export const listarEventos = async (params = {}) => {
  const { data } = await api.get(`${BASE}/eventos`, { params });
  return data;
};

export const contarEventos = async () => {
  const { data } = await api.get(`${BASE}/eventos/contar`);
  return data;
};

export const obterEngineStatus = async () => {
  const { data } = await api.get(`${BASE}/engine/status`);
  return data;
};

export const testarSMTP = async () => {
  const { data } = await api.get(`${BASE}/smtp/teste`);
  return data;
};

// Variáveis disponíveis nos templates (para exibir na UI).
export const VARIAVEIS_TEMPLATE = [
  { chave: '{nome}', descricao: 'Nome do cliente' },
  { chave: '{valor}', descricao: 'Valor em aberto (formatado)' },
  { chave: '{vencimento}', descricao: 'Data de vencimento (dd/mm/yyyy)' },
  { chave: '{documento}', descricao: 'Número do documento' },
  { chave: '{dias_atraso}', descricao: 'Dias de atraso (negativo se ainda não venceu)' },
  { chave: '{empresa}', descricao: 'Nome da loja remetente' },
  { chave: '{idconta}', descricao: 'Número interno da conta' },
];

export const STATUS_EVENTO_INFO = {
  enfileirado: { label: 'Enfileirado', cor: 'info' },
  enviado: { label: 'Enviado', cor: 'success' },
  erro: { label: 'Erro', cor: 'danger' },
  pulado: { label: 'Pulado', cor: 'secondary' },
};

const cobrancaService = {
  listarEtapas,
  atualizarEtapa,
  listarEventos,
  contarEventos,
  obterEngineStatus,
  testarSMTP,
  VARIAVEIS_TEMPLATE,
  STATUS_EVENTO_INFO,
};

export default cobrancaService;
